import {
  TimelineMax,
  TweenMax,
  Sine
} from "gsap";
// TimelineMax, Power2, Elastic, CSSPlugin ,Tweenmax
export function play() {

  // TweenMax.set(".b93a40bd-360b-4041-bb64-cedb853ee264:nth-child(2n)", {
  //   css: {
  //     display: 'none'
  //   }
  // })

  let tl = new TimelineMax();
  let tl2 = new TimelineMax();
  tl.to("[data-name='coin_market']", 0.5, {
    y: -50,
    ease: Sine.easeInOut
  }).to("[data-name='coin_market']", 1, {
    y: -100,
    opacity: 0,
  }).repeat(-1)

  var tl3 = new TimelineMax()
  tl3.to("[data-name='coin_school']", 0.5, {
    y: -50,
    ease: Sine.easeInOut
  }).to("[data-name='coin_school']", 1, {
    y: -100,
    opacity: 0,
  }).repeat(-1).delay(0.5)


  tl2.to("[data-name='mrt']", 5, {
    x: -70,
    y: 50,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)


  let logo = `[data-name="logo"]`

  // scaleY:0, 
  TweenMax.set(logo, {
    scaleX: -1,
    transformOrigin: "50% 50% 0%"
    // transformOrigin: "50% 100% 100%"
  })
  TweenMax.to(logo, 2, {
    scaleX: 1,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  // var tlLogo = new TimelineMax()
  // tlLogo.to(logo, 1, {
  //   rotationZ: 10,
  // }).to(logo, 1, {
  //   rotationZ: -10,
  // }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="lady"]`, {
    transformOrigin: "20% 100%"
  })
  TweenMax.to(`[data-name="lady_hand"]`, 1, {
    rotate: -50,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  TweenMax.to(`[data-name="lady"]`, 3, {
    rotate: -2,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="boss_hand"]`, {
    transformOrigin: "100% 30%"
  })
  TweenMax.to(`[data-name="boss_hand"]`, 1.2, {
    rotate: -50,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)


  TweenMax.set(`[data-name="mom_hand"]`, {
    transformOrigin: "0% 0%"
  })
  TweenMax.to(`[data-name="mom_hand"]`, 1.2, {
    rotate: -20,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)



  TweenMax.set(`[data-name="kid_hand"]`, {
    transformOrigin: "100% 100%"
  })
  TweenMax.to(`[data-name="kid_hand"]`, 1.2, {
    rotate: -20,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)


}